import {Injectable} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import 'rxjs/add/operator/map';


interface Response {
  shipments?: any;
  payment?: any;
  billing_address?: any;
  errors?: any;
  message?: any;
}

export interface ShipmentPaymentStatusElement {
  errors?: Array<{ field: string, value: string }>;
  tip?: string;
  update?: boolean;
  remove?: boolean;
}


@Injectable()
export class OrderCreationService {

  handleOrderCreationErrors(error: HttpErrorResponse): {
    shipmentPaymentStatuses: Array<ShipmentPaymentStatusElement>, paymentError: string,
  } {
    const shipmentPaymentStatuses: Array<ShipmentPaymentStatusElement> = [];
    let paymentError: string = '';
    const response: Response = error.error;
    // 422 status
    if (response.shipments) {
      Object.keys(response.shipments).forEach((key: any, index: number) => {
        shipmentPaymentStatuses[key] = {};
        shipmentPaymentStatuses[key].errors = [];
        const shipmentErrors = response.shipments[key];
        Object.keys(shipmentErrors).forEach(errKey => {
          if (errKey === 'incorrect_data') {
            // *1
            shipmentPaymentStatuses[key] = {
              ...shipmentPaymentStatuses[index],
              errors: Object.keys(shipmentErrors[errKey]).map((key) => ({
                field: key,
                value: shipmentErrors[errKey][key]
              })),
              update: true,
              tip: 'account.section.createConsignment.errors.updateTip',
            };
            paymentError = 'account.section.createConsignment.errors.dataErr';
          } else {
            shipmentPaymentStatuses[key] = {
              ...shipmentPaymentStatuses[key],
              tip: 'account.section.createConsignment.errors.removeTip',
              update: false,
              remove: true,
            };
            paymentError = 'account.section.createConsignment.errors.userDataErr';
          }
        });
      });
    }

    if (response.errors) {
      // *2
      paymentError = response.message + '<p>';
      Object.keys(response.errors).forEach(key => {
        const index = key.split('.')[1];
        const shipmentCount = parseInt(index, 10) + 1;
        paymentError += '<strong>Shipment ' + shipmentCount + ':</strong>';
        paymentError += '<ul>';
        response.errors[key].forEach(errorMessage => {
          paymentError += '<li>' + errorMessage + '</li>';
        });
        paymentError += '</ul>';
        shipmentPaymentStatuses[index] = {
          tip: 'payment.removeTip',
          update: false,
          remove: true,
        };
      });
      paymentError += '</p>';
    }
    if (response.payment) {
      // *4
      paymentError = response.payment;

    }
    if (response.billing_address) {
      paymentError = 'account.section.createConsignment.errors.billingErr';
    }

    switch (error.status) {
      case 400:
        paymentError = 'account.section.createConsignment.errors.badRequest';
        break;
      case 422:
        break;
      default:
        paymentError = 'account.section.createConsignment.errors.serverErr';
        break;
    }
    return {
      paymentError,
      shipmentPaymentStatuses
    }
  }
}

/*
  possible responses:
  1
  {
  "shipments": [
    {
      "incorrect_data": {
        "charge": 92,
        "pickup_date": "2018-09-03",
        "delivery_date": "2018-09-04",
        "vat": 23
      }
    }
  ]
}

{
  "shipments": {
    "1": {
      "incorrect_data": {
        "charge": 92,
        "delivery_date": "2018-09-03",
        "vat": 23
      }
    }
  }
}

{
        "shipments": [
          {
            "incorrect_data": {
              "charge": 92,
              "delivery_date": "2018-09-03",
              "vat": 23
            }
          },
          {
            "incorrect_data": {
              "charge": 92,
              "delivery_date": "2018-09-03",
              "vat": 23
            }
          }
        ]
      };


2
{
  "message": "The given data was invalid.",
  "errors": {
    "shipments.0.details.pickup_date": [
      "The pickup date must be a date after or equal today."
    ],
    "shipments.1.details.pickup_date": [
      "The pickup date must be a date after or equal today."
    ]
  }
}

3
{
  "shipments": {
    "1": [
      {
        "code": "errAgreementName",
        "description": "Unable to find agreement with name 'DHL Express Global 3rd party' for Part with role 'payer'",
        "level": 1
      },
      {
        "code": "ERR_AGREEMENT_THIRD",
        "description": "Avtal saknas för annan fraktbetalare.",
        "level": 1
      }
    ]
  }
}

{
  "shipments": [
    [
      {
        "code": "errAgreementName",
        "description": "Unable to find agreement with name 'DHL Express Global 3rd party' for Part with role 'payer'",
        "level": 1
      },
      {
        "code": "ERR_AGREEMENT_THIRD",
        "description": "Avtal saknas för annan fraktbetalare.",
        "level": 1
      }
    ]
  ]
}
 */

/*
billing address error
* {
  "message": "The given data was invalid.",
  "errors": {
    "billing_address.email": [
      "The billing address email must be a valid email address."
    ]
  }
}
*
* */
/*
 payment error
4
{
  "payment":"Invalid card number",
  "order_id":158
}
*/




// WEBPACK FOOTER //
// ./src/app/services/order-creation.service.ts